export const APPLIED_MODIFY_EVENT = 'applied-modify-event';
export const CREATE_HOLIDAY_KEY = 'create_holiday';
export const HOLIDAY_DETAILS_KEY = 'holiday_details';
export const EDIT_HOLIDAY_KEY = 'edit_holiday';
export const DC_COUNTRY_ID = 28;
export const HOLIDAY_DATE_FORMAT = 'YYYY-MM-DDT00:00:00Z';
